module.exports = __webpack_public_path__ + "static/media/post-01.87c51e31.jpg";